import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './storeConfiguration';

import rootReducer from './reducers/index.js';

import Clients from './components/clients.jsx';

function setClientReact() {
    let store = configureStore(rootReducer);
    
    ReactDOM.render(
    <Provider store={store}>
        <Clients/>
    </Provider>,
    document.getElementById('client-box'));
}

function init() {
    if (document.getElementById('client-box') !== null) {
        setClientReact();
    }
}

export { init }




// WEBPACK FOOTER //
// ./src/_app/clients/index.js